<div class="modal-header">
  <h4 class="modal-title fw-normal">Upload File</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="onCancel()"></button>
</div>

<div class="modal-body">
  <section class="text-center">
    <div class="dropzone-wrapper mx-auto">
      <app-file-dropzone
        iconClass="bi-cloud-upload"
        primaryText="Drag & drop file here"
        (filesSelected)="onFilesSelected($event)"
      />
    </div>

    @if (hasFiles()) {
    <div class="file-list-container mx-auto mt-3">
      @for (entry of files(); track entry.file.name + entry.file.lastModified) {
      <div class="file-list-item d-flex align-items-center border px-3 py-2 mb-2 bg-white rounded-3 gap-3 bg-light">
        <div class="file-item-left d-flex align-items-center gap-1 flex-grow-1">
          <div class="file-thumbnail d-flex align-items-center justify-content-center rounded-2">
            @if (entry.previewUrl) {
            <img [src]="entry.previewUrl" [alt]="entry.file.name" class="file-thumbnail-img" />
            } @else {
            <i class="fs-1" [ngClass]="[entry.badge?.iconClass, entry.badge?.textClass]"></i>
            }
          </div>
          <div class="flex-grow-1 text-truncate text-start">
            <p class="fw-semibold mb-0 small text-truncate">{{ entry.file.name }}</p>
          </div>
        </div>
        <button class="btn btn-close px-2 py-0 flex-shrink-0 ms-auto" type="button" (click)="removeFile(entry)"
          aria-label="Remove file"></button>
      </div>
      }
    </div>
    }
  </section>
</div>

<div class="modal-footer">
  <button class="btn btn-primary" type="button" (click)="onNext()" [disabled]="!hasFiles()">
    Next
  </button>
</div>
